/**
 * AdminCalendar Component
 *
 * Calendar and task management page for RSH Portal admin interface.
 * Displays full calendar view with tasks, deadlines, and scheduling.
 *
 * @component
 */

import React from "react";
//import AdminNavbar, { AdminDesktopFooter, AdminMobileFooter } from "./AdminNavbar";
import { FaCalendarAlt } from "react-icons/fa";
import AdminPageBanner from "../../components/admin/AdminPageBanner";
import "./AdminCalendar.css";

/**
 * AdminCalendar Component
 *
 * @param {Object} props - Component props
 * @param {Object} props.user - Firebase user object
 * @param {Object} props.userData - User data from Team table
 * @returns {JSX.Element} Admin calendar page
 */
function AdminCalendar({ user, userData }) {
  return (
    <div className="ac-container">
      <AdminPageBanner title="Calendar Management" subtitle="COMING SOON">
        <div className="apb-icon">
          <FaCalendarAlt />
        </div>
      </AdminPageBanner>
    </div>
  );
}

export default AdminCalendar;
